// Messages for operator/companies/CompanyFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.company_form.title.edit': 'Edit company',
  'operator.company_form.title.add_customer': 'Add customer',
  'operator.company_form.title.add_carrier': 'Add carrier',
  'operator.company_form.cancel': 'Cancel',
  'operator.company_form.save_changes': 'Save changes',
  'operator.company_form.create': 'Create',
  'operator.company_form.field.name': 'Name',
  'operator.company_form.field.code': 'Code',
  'operator.company_form.field.email': 'Email',
  'operator.company_form.field.contact': 'Contact person',
  'operator.company_form.field.phone': 'Phone',
}

export const zhTW = {
  'operator.company_form.title.edit': '編輯公司',
  'operator.company_form.title.add_customer': '新增客戶',
  'operator.company_form.title.add_carrier': '新增承運商',
  'operator.company_form.cancel': '取消',
  'operator.company_form.save_changes': '儲存變更',
  'operator.company_form.create': '建立',
  'operator.company_form.field.name': '名稱',
  'operator.company_form.field.code': '代碼',
  'operator.company_form.field.email': '電子郵件',
  'operator.company_form.field.contact': '聯絡人',
  'operator.company_form.field.phone': '電話',
}
